import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { Card } from "react-bootstrap";

//
import Clock from "../../../assets/img/clock.png";

//
import ImageBox from "../../../components/general/ImageBox";

//
import { showPlanModal } from "../../../redux/features/plan/slice";

function CurrentPlan({ plan, user, showPlanModal }) {
  const [features, setFeatures] = useState([]);

  const set_features = () => {
    let featureList = [];
    for (const [key, value] of Object.entries(plan.features)) {
      if (value.active) {
        featureList.push(value.title);
      }
    }

    setFeatures(featureList);
  };

  useEffect(() => {
    set_features();
  }, [plan]);

  return (
    <Card className="current-plan bordered">
      <Card.Body>
        <header>
          <div className="name-price">
            <ImageBox src={Clock} />
            <div className="name-box">
              <h5>{plan.name}</h5>
              <p>
                {+plan.price_usd > 0 ? `$${plan.price_usd}` : "Free"}
                {plan.price_point && <span>or {plan.price_point} Points</span>}
              </p>
            </div>
          </div>
          {/* <p
            className="fw-extra-bolder text-info pointer upgrade"
            onClick={() => showPlanModal({ show: true, step: "choose-plan", type:"plan" })}
          >
            Upgrade Plans
          </p> */}
        </header>

        <div className="content">
          <p className="subject">{plan.description}</p>

          <div className="permissions">
            {features.map((item, index) => (
              <p key={index}>
                <i className="las la-check"></i>
                <span>{item}</span>
              </p>
            ))}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

const mapDispatchToProps = {
  showPlanModal,
};

CurrentPlan.propTypes = {
  showPlanModal: PropTypes.func.isRequired,
  plan: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  plan: state.userReducer.plan,
  user: state.userReducer.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(CurrentPlan);
